<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="true"
  [draggable]="false"
  class="font-['Wigrum-Regular']">
  <ng-template pTemplate="header">
    <div class="ml-auto mr-auto p-4 bg-lightest rounded-md w-full">
      <h1 class="white-space-nowrap text-xl flex justify-center font-['Wigrum-Regular'] text-darkest">
        {{ "receipt.configureEcheancierGeneration" | translate }}
      </h1>
    </div>
  </ng-template>

  <section class="col-span-full flex flex-row">
    <button
      pButton
      label="Oui"
      type="button"
      class="bg-primary text-white p-2 mr-3 font-bold w-full"
      (click)="generateEcheancier(true)"></button>
    <button
      pButton
      label="Non"
      type="button"
      class="bg-white border-primary border-solid border-[1px] p-2 mr-3 text-primary font-bold w-full"
      (click)="generateEcheancier(false)"></button>
    <button
      pButton
      type="button"
      label="Annuler"
      class="bg-white border-primary border-solid border-[1px] p-2 text-primary font-bold w-full"
      (click)="hide()"></button>
  </section>
</p-dialog>
